/**
 * TB-App API – Generated by orval 🍺
 * Do not edit manually.
 */

export type TuberculosisHistoryDtoPreviousTuberculosis =
  (typeof TuberculosisHistoryDtoPreviousTuberculosis)[keyof typeof TuberculosisHistoryDtoPreviousTuberculosis];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const TuberculosisHistoryDtoPreviousTuberculosis = {
  YES: 'YES',
  NO: 'NO',
  UNKNOWN: 'UNKNOWN',
} as const;
